module.exports = __webpack_public_path__ + "img/6.68e2f30b.png";